module.exports = __webpack_public_path__ + "static/media/hot_ycgs.bac7f477.png";